import {Button, Input, Modal, Select, Typography} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Dragable, {DraggableData, DraggableEvent} from "react-draggable";
import {userAPI} from "../../services/UserService";
import {objectAPI} from "../../services/ObjectService";
import '../ModalStyles.scss';
import {UserModel} from "../../models/UserModel";
import {ObjectModel} from "../../models/ObjectModel";
import {RoleModel} from "../../models/RoleModel";
import {ROLES} from "../../config/constants";
import {Checkbox} from 'antd';
import type {CheckboxChangeEvent} from 'antd/es/checkbox';

const {Text} = Typography;

type ModalProps = {
    infoNotification: Function,
    errorNotification: Function,
    user: UserModel,
    setVisible: Function,
    getUsers: Function,
}

export const UpdateUserModal = (props: ModalProps) => {
    const [updateUser, {
        error: errorUpdateUser,
        isSuccess: isSuccessUpdateUser,
        isError: isErrorUpdateUser,
        isLoading: isLoadingUpdateUser
    }] = userAPI.useUpdateUserMutation();
    const [getObjectsRequest, {
        data: dataGetObjectsRequest,
        isLoading: isGettingObjectsInProcess,
    }] = objectAPI.useGetObjectsNoEquipmentsMutation();
    const [deleteUser, {
        isSuccess: isSuccessDeleteUser,
        isError: isErrorDeleteUser,
        error: errorDeleteUser
    }] = userAPI.useDeleteUserMutation();
    // Draggable settings
    const [disabled, setDisabled] = useState<boolean>(false);
    const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggableRef = useRef<HTMLDivElement>(null);
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggableRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top - uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        })
    }
    // End of dnd
    const [name, setName] = useState<string>(props.user.name);
    const [surname, setSurname] = useState<string>(props.user.surname);
    const [secondName, setSecondName] = useState<string>(props.user.secondName);
    const [username, setUsername] = useState<string>(props.user.username);
    const [email, setEmail] = useState<string>(props.user.email);
    const [phone, setPhone] = useState<string>(props.user.phone);
    const [updatePassword, setUpdatePassword] = useState<boolean>(false);
    const [password, setPassword] = useState<string>();
    const [selectedObjects, setSelectedObjects] = useState<number[]>(() => {
        const result: (number | undefined)[] = props.user.objects.map((object: ObjectModel) => {
            if (object.id) return Number(object.id)
        })
        return result as number[]
    });
    const [selectedRole, setSelectedRole] = useState<string>(props.user.role);
    const [modalWidth,] = useState<number>(600);
    const handleUpdateUser = () => {
        if (name && surname && secondName && username && email && phone && selectedRole && dataGetObjectsRequest) {
            const user: UserModel = {
                id: props.user.id,
                name,
                surname,
                secondName,
                email,
                username,
                phone,
                //@ts-ignore
                objectsCode: selectedObjects,
                role: selectedRole,
                password: updatePassword ? password?.trim() ?? '' : '',
            };
            updateUser(user);
        }
    }
    const handleDeleteUser = () => {
        if (props.user.username) deleteUser(props.user.username);
    }
    useEffect(() => {
        getObjectsRequest();
    }, []);
    useEffect(() => {
        if (isErrorUpdateUser && errorUpdateUser) {
            if (errorUpdateUser.toString() === '422')
                props.errorNotification("Что-то не уникально или что-то другое")
            else
                props.errorNotification(JSON.stringify(errorUpdateUser))
        }
    }, [isErrorUpdateUser]);
    useEffect(() => {
        if (isErrorDeleteUser && errorDeleteUser) {
            if (errorDeleteUser.toString() === '400')
                props.errorNotification("Что-то не уникально или что-то другое")
            else
                props.errorNotification(JSON.stringify(errorDeleteUser))
        }
    }, [isErrorDeleteUser]);
    useEffect(() => {
        if (isSuccessUpdateUser || isSuccessDeleteUser) {
            props.getUsers()
            props.setVisible(false)
        }
        if (isSuccessDeleteUser) props.infoNotification("Пользователь удален")
        if (isSuccessUpdateUser) props.infoNotification("Пользователь обновлен")
    }, [isSuccessUpdateUser, isSuccessDeleteUser]);
    // @ts-ignore
    return (
        <Modal
            title={'Редактирование пользователя'}
            centered={true}
            open={true}
            footer={[]}
            modalRender={(modal) => (
                // @ts-ignore
                <Dragable
                    disabled={disabled}
                    bounds={bounds}
                    onStart={(event, uiData) => onStart(event, uiData)}
                >
                    <div ref={draggableRef}>{modal}</div>
                </Dragable>
            )}
            width={modalWidth}
            onCancel={() => props.setVisible(false)}
        >
            <div className="modalFlex">
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Выбор объектов</Text>
                    {dataGetObjectsRequest &&
                        <Select
                            allowClear
                            mode={'multiple'}
                            defaultValue={selectedObjects}
                            disabled={isGettingObjectsInProcess}
                            onChange={setSelectedObjects}
                            style={{width: '100%'}}
                            options={dataGetObjectsRequest && dataGetObjectsRequest.map((item: ObjectModel) => ({
                                value: item.id,
                                label: `${item.filial.code} ${item.filial.name} ${item.name}`,
                            }))}
                        />}
                    {!dataGetObjectsRequest &&
                        <Select
                            mode={'multiple'}
                            disabled={true}
                            style={{width: '100%'}}
                        />}
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Выбор роли</Text>
                    <Select
                        value={selectedRole}
                        onChange={setSelectedRole}
                        style={{width: '100%'}}
                        options={ROLES.map((item: RoleModel) => ({
                            value: item.code,
                            label: item.name,
                        }))}
                    />
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Имя</Text>
                    <Input value={name} onChange={(e: any) => setName(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Фамилия</Text>
                    <Input value={surname} onChange={(e: any) => setSurname(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Отчество</Text>
                    <Input value={secondName} onChange={(e: any) => setSecondName(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Логин</Text>
                    <Input value={username} onChange={(e: any) => setUsername(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Почта</Text>
                    <Input value={email} onChange={(e: any) => setEmail(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Text style={{marginBottom: 5}}>Телефон</Text>
                    <Input value={phone} onChange={(e: any) => setPhone(e.target.value)}/>
                </div>
                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalInput">
                    <Checkbox style={{marginBottom: 5}} onChange={(e: CheckboxChangeEvent) => setUpdatePassword(e.target.checked)}>Задать новый пароль</Checkbox>
                    <Input disabled={!updatePassword} value={password} onChange={(e: any) => setPassword(e.target.value)}/>
                </div>

                <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                     className="modalButtons">
                    <Button disabled={isLoadingUpdateUser} onClick={handleUpdateUser}>Сохранить</Button>
                    <Button onClick={() => props.setVisible(false)}>Отменить</Button>
                    <Button danger onClick={handleDeleteUser}>Удалить</Button>
                </div>
            </div>
        </Modal>
    )
}